<template>
  <header class="top-0 w-full sticky z-50">
    <div
      class="flex container items-center justify-center mx-auto p-3 flex-row"
    >
      <div class="w-full md:w-11/12 flex justify-between md:justify-center">
        <div class="logo md:pl-44 h-9 md:h-20">
          <slot name="header-logo_image">
            <router-link to="/">
              <img src="@/assets/gemnote_logo_pebble.png" alt="" />
            </router-link>
          </slot>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Pageheader'
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

header {
  border-bottom: solid 1px;
  height: 80px;
  display: flex;
  align-items: center;

  .logo {
    a {
      height: inherit;
      img {
        height: inherit;
        object-fit: contain;
      }
    }
  }
}

@media (min-width: 768px) {
  header {
    height: 120px;
  }
}
</style>
